import type {ReactNode} from 'react';

import {Stack} from 'shells/layout/stack/stack';

interface Props {
    children: ReactNode;
}

export function PeepHeaderRightLayout(props: Props) {
    const {children} = props;

    return (
        <Stack
            spacing={NutClientConfig.hasCoreEntityFullHeightSidebarFF ? 0 : 8}
            isFullWidth={true}
        >
            {children}
        </Stack>
    );
}
